module.exports = __webpack_public_path__ + "img/chevron-contract.e158e813.svg";